import React, { createContext, useContext, useState } from 'react';

const BookContext = createContext();

export const useBook = () => {
	const context = useContext(BookContext);
	return context;
};

export const BookProvider = ({ children }) => {
	const [book, setBook] = useState(null);

	return (
		<BookContext.Provider value={{ book, setBook }}>
			{children}
		</BookContext.Provider>
	);
};

